import Vue from 'vue'
import Echo from 'laravel-echo' /* Make App Realtime */
import VueEcho from 'vue-echo' /* Vue Wrapper for laravel echo */
import store from '~/store'

const host = window.location.hostname === 'pantybay.com' ? `${window.location.hostname}` : `${window.location.hostname}:6002`

if (typeof io !== 'undefined') {
  const authenticationToken = localStorage.getItem('vue-authenticate.vueauth_token')
  const authenticated = store.getters['auth/isAuthenticated']
  window.Echo = Echo
  const EchoInstance = new Echo({
    namespace: 'App\\Events',
    broadcaster: 'socket.io',
    host: `${host}`,
    path: '/ws/socket.io',
    auth: {
      headers: {
        Authorization: (authenticated) ? `Bearer ${authenticationToken}` : ''
      }
    }
  })
  /* Install VueEcho: this.$echo */
  Vue.use(VueEcho, EchoInstance)
}



// WEBPACK FOOTER //
// ./resources/js/services/echo.js